
import {
  LEGAL_ONEY,
  LEGAL_PAYPAL,
  LEGAL_PAYPAL_ABROAD,
  legalNotices,
} from '@/utils/paymentOffers'

export default {
  name: 'PaymentLegalNotices',
  props: {
    amount: {
      type: Number,
      default: undefined,
    },
    shown: {
      type: Array,
      default: undefined,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    offers() {
      return this.$store.getters.payment_offers
    },
    notices() {
      return legalNotices(this.offers, this.amount, this.shown).map(key => ({
        key,
        text: this.noticeText(key),
      }))
    },
    showsCreditWarning() {
      return this.notices.some(({ key }) =>
        [LEGAL_PAYPAL, LEGAL_PAYPAL_ABROAD].includes(key)
      )
    },
  },
  methods: {
    noticeText(key) {
      if (key === LEGAL_ONEY) {
        return this.$t('components.paymentLegalNotices.oney', {
          minimum: this.offers.oney.minimum.toLocaleString(this.$i18n.locale),
        })
      }
      if (key === LEGAL_PAYPAL) {
        return this.$t('components.paymentLegalNotices.paypal')
      }
      if (key === LEGAL_PAYPAL_ABROAD) {
        return this.$t('components.paymentLegalNotices.paypalAbroad')
      }
      return ''
    },
  },
}
